import script from "./account-details-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./account-details-modal.vue?vue&type=script&setup=true&lang=ts"

import "./account-details-modal.vue?vue&type=style&index=0&id=008f65ae&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008f65ae"]])

export default __exports__